import { get, post, put } from './http-calls';

export const getTcardData = async (branchID, startDate, endDate) => {
    let res = await get(`TCards/TCards_GetDashboard?BranchID=${branchID}&startDate=${startDate}&EndDate=${endDate}`, { useAuthToken: true });
    return res;
};
export const getTcardBookingData = async (branchID, startDate, endDate) => {
    let res = await get(`TCards/TCards_GetBookingDashboard?startDate=${startDate}&EndDate=${endDate}&BranchID=${branchID}`, { useAuthToken: true });
    return res;
};

export const getTCardWipData = async (branchID) => {
    let res = await get(`TCards/TCards_GetWIPTCards?BranchID=${branchID}`, { useAuthToken: true });
    return res;
};
export const getTcardBranchData = async (data) => {
    let res = await get(`TCards/TCardDash_DropDowns`, { useAuthToken: true });
    return res;
};

export const postTCardsDragStatus = async (data) => {
    let res = await post(`TCards/TCard_StatusUpdate`, data, { useAuthToken: true });
    return res;
};
export const postTCardsDragStatusBookingDate = async (data) => {
    let res = await post(`TCards/TCard_ChangeBookingDate`, data, { useAuthToken: true });
    return res;
};
export const postTCardMOTClose = async (data) => {
    let res = await post(`TCardCalendars/TCardCalendar_SetMOTClosed`, data, { useAuthToken: true });
    return res;
};
export const postTCardCalendar_SetDayFull = async (data) => {
    let res = await post(`TCardCalendars/TCardCalendar_SetDayFull`, data, { useAuthToken: true });
    return res;
};
export const postTCardCalendarNotes = async (data) => {
    let res = await post(`TCardCalendars/TCardCalendar_SetNote`, data, { useAuthToken: true });
    return res;
};
